import React from "react"

import { Row, Col, Card, CardBody, CardTitle } from "reactstrap"
import { Link } from "react-router-dom"

import ApexRadial from "./ApexRadial"
import tawgehMouna from "../../assets/images/certificate/02-tawgeh-mouna.jpg"
import tawgehAisha from "../../assets/images/certificate/01-tawgeh-aisha.jpg"
import tawgehMohamed from "../../assets/images/certificate/03-tawgeh-mohamed.jpg"
import hassanBinThabetSchool from "../../assets/images/certificate/02-hassan-bin-thabit.jpg"
import hassanBinThabetwaleed from "../../assets/images/certificate/02-hassn-bin-thabit-waleed.jpg"
import mohamedRabe3 from "../../assets/images/certificate/01-bin-taymmah-mohamed-rabe3.jpg"
import mohamedAbd from "../../assets/images/certificate/01-bin-taymmah-mohamed-abd.jpg"
import binTaymeeya from "../../assets/images/certificate/01-bin-taymmah.jpg"
// import putExamWaleed from "../../assets/images/certificate/02-put-exam.jpg"

const MonthlyEarning = ({ schoolNewData }) => {
  return (
    <React.Fragment>
      {" "}
      <Card>
        <CardBody style={{ padding: "10px" }}>
          <CardTitle className="mb-4">متوسط الدرجات الكلي للمدارس</CardTitle>
          <Row>
            <Col sm="6">
              <div className="">
                <ApexRadial
                  dataColors='["--bs-primary"]'
                  schoolNewData={schoolNewData}
                />
              </div>
            </Col>
            <Col sm="6" dir="rtl" className="teachersData">
              {/* <p className="text-muted">المعلمين / المعلمات</p> */}
              {/* <h3>-</h3> */}
              {/* <p className="text-muted">
                <span className="text-success me-2">
                  {" "}
                  3
                </span>{" "}
                الموجهين
              </p> */}

              <details style={{ marginBottom: "10px" }}>
                <summary
                  style={{
                    backgroundColor: "#d4dbf9",
                    padding: "5px",
                    marginBottom: "5px",
                  }}
                >
                  <span
                    style={{ display: "inline-block", marginRight: "10px" }}
                  >
                    توجيه تربوي
                  </span>
                </summary>
                <div>
                  <Row className="highlighted-row">
                    <Col xs="10"  className="p-0">
                      <span>أ/منى اليافعي</span>
                    </Col>
                    <Col xs="2"  className="p-0">
                      <a
                        className=""
                        href={tawgehMouna}
                        download="Mrs-Mouna.jpg"
                      >
                        <span>
                          <i className="fa fa-download"></i>
                        </span>
                      </a>
                    </Col>
                  </Row>
                  <Row className="highlighted-row">
                    <Col xs="10"  className="p-0">
                      <span>أ/عائشة المسيفري</span>
                    </Col>
                    <Col xs="2"  className="p-0">
                      <a href={tawgehAisha} download="mrs-aisha.jpg">
                        <span>
                          <i className="fa fa-download"></i>
                        </span>
                      </a>
                    </Col>
                  </Row>
                  <Row className="highlighted-row">
                    <Col xs="10"  className="p-0">
                      <span>أ/محمد فؤاد حسيب</span>
                    </Col>
                    <Col xs="2" className="p-0">
                      <a href={tawgehMohamed} download="image.jpg">
                        <span>
                          <i className="fa fa-download"></i>
                        </span>
                      </a>
                    </Col>
                  </Row>
                </div>
              </details>

              {/* <span className="text-success me-2"> 2</span> واضعي الامتحان */}
              <details style={{ marginBottom: "15px" }}>
                <summary
                  style={{
                    backgroundColor: "#d4dbf9",
                    padding: "5px",
                    marginBottom: "5px",
                  }}
                >
                  <div className="d-inline-block">
                    <span>مدرسة حسان بن ثابت</span>
                    <a
                      href={hassanBinThabetSchool}
                      download="hassan-bin-thabit.jpg"
                      className="d-inline-block"
                      style={{ marginRight: "10px" }}
                    >
                      <span>
                        <i className="fa fa-download"></i>
                      </span>
                    </a>
                  </div>
                </summary>
                <div>
                  <Row className="highlighted-row">
                    <Col xs="10" className="p-0">
                      <span>أ/ وليد ابراهيم الششتاوي</span>
                    </Col>
                    <Col xs="2" className="p-0">
                      <a
                        href={hassanBinThabetwaleed}
                        download="Mr-Waleed-Ibrahim.jpg"
                      >
                        <i className="fa fa-download"></i>
                      </a>
                    </Col>
                  </Row>
                </div>
              </details>

              <details>
                <summary
                  style={{
                    backgroundColor: "#d4dbf9",
                    padding: "5px",
                    marginBottom: "10px",
                  }}
                >
                  <div className="d-inline-block">
                    <span>مدرسة بن تيمية </span>
                    <a
                      href={binTaymeeya}
                      download="Bin-Taymmah.jpg"
                      className="d-inline-block"
                      style={{ marginRight: "10px" }}
                    >
                      <span>
                        <i className="fa fa-download"></i>
                      </span>
                    </a>
                  </div>
                </summary>
                <div>
                  <Row className="highlighted-row">
                    <Col xs="10" className="p-0">
                      <span>أ/ محمد ربيع</span>
                    </Col>
                    <Col xs="2" className="p-0">
                      <a href={mohamedRabe3} download="Mr-Mohamed-Rabea.jpg">
                        <span>
                          <i className="fa fa-download"></i>
                        </span>
                      </a>
                    </Col>
                  </Row>
                  <Row className="highlighted-row">
                    <Col xs="10"  className="p-0">
                      <span>أ/ محمد عبد العظيم</span>
                    </Col>
                    <Col xs="2" className="p-0">
                      <a href={mohamedAbd} download="Mr-Mohamed-AbdelAzim.jpg">
                        <span>
                          <i className="fa fa-download"></i>
                        </span>
                      </a>
                    </Col>
                  </Row>
                </div>
              </details>
            </Col>
          </Row>
          {/* <p className="text-muted mb-0">
            We craft digital, graphic and dimensional thinking.
          </p> */}
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default MonthlyEarning
